import Vue from 'vue'
import VeeValidate from 'vee-validate'
import i18n from './i18n'

const dict = i18n.messages[i18n.locale].validation

VeeValidate.Validator.localize(i18n.locale, dict)

Vue.use(VeeValidate, { errorBagName: 'v_errors', fieldsBagName: 'v_fields' })
